const header = {
  header: {
    logOut: 'ログアウト',
    enphaseStore: 'Enphase Store',
    enphaseSupport: 'Enphase Support',
    comingSoon: '近日公開',
    new: '新規',
    dashboard: 'ダッシュボード',
    leads: 'リード',
    systems: 'システム',
    account: 'アカウント',
    services: 'サービス',
    dataPrivacy: 'データ & プライバシー',
    support: 'サポート',
    admin: '管理者',
    adminNew: '管理者(新規)'
  }
};

export default header;
